import classNames from 'classnames';

import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';

const useStyles = makeStyles({
  empty: {
    minHeight: 300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#818D99',
  },
  icon: {
    color: '#818D99',
    fontSize: '50px',
  },
  description: {
    fontSize: 28,
    marginTop: 30,
  },
  createNew: {
    marginTop: 20,
  },
});

interface Props {
  className?: string;
}

function Empty({ className }: Props) {
  const intl = useIntl();
  const styles = useStyles();

  const fmtEmpty = intl.formatMessage({ id: 'shootings.empty' });
  const fmtCreateNew = intl.formatMessage({ id: 'shootings.createNew' });

  return (
    <Paper className={classNames(className, styles.empty)}>
      <CalendarTodayOutlinedIcon className={styles.icon} />
      <Typography className={styles.description}>{fmtEmpty}</Typography>
      <Typography className={styles.createNew}>{fmtCreateNew}</Typography>
    </Paper>
  );
}

Empty.defaultProps = {
  className: null,
};

Empty.propTypes = {
  className: PropTypes.string,
};

export default Empty;
